export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-3xl border border-background-200/70 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-6 md:p-10">
            <div className="flex-1 w-full text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                移动直达
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-md mx-auto lg:mx-0">
                五一吃瓜网已全面适配移动端浏览器访问。无需下载任何 App，在手机浏览器输入官方地址即可流畅浏览全部吃瓜内容。支持将本站添加到手机桌面，一键直达最新吃瓜资讯。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold cursor-pointer whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  手机浏览器直达
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-200/70 text-foreground-700 rounded-full text-sm font-medium cursor-pointer whitespace-nowrap">
                  <i className="ri-add-circle-line"></i>
                  添加到桌面
                </span>
              </div>
            </div>
            <div className="flex-shrink-0 w-48 md:w-56">
              <div className="aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200/70">
                <img
                  src="https://readdy.ai/api/search-image?query=Mobile%20browser%20screenshot%20mockup%20showing%20modern%20news%20feed%20interface%20with%20warm%20crimson%20and%20golden%20accent%20colors%2C%20entertainment%20headlines%20with%20thumbnail%20images%2C%20clean%20Chinese%20typography%20layout%2C%20minimalist%20UI%20design%20with%20card%20style%20content%20blocks%2C%20soft%20warm%20background%20with%20subtle%20gradients&width=360&height=640&seq=app-mock&orientation=portrait"
                  alt="五一吃瓜网移动端页面预览"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}